import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DatePicker, DefaultButton, Panel, PrimaryButton, SpinButton, Stack, TextField} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";
import {dbDate} from "../../Utilities/dbDate";

function EditVentureMilestone(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [date, setDate] = useState('');
    const [completion, setCompletion] = useState(0);

    const _submit = (e) => {
        e.preventDefault();
        const data = {name: name, description: description, completion: completion, date: dbDate(date)};
        fetch(`/api/venture/${props.edit.venture_id}/milestone/${props.edit.id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='EditVentureMilestone'>Edytuj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        setName(props.edit.name ?? '');
        setDescription(props.edit.description ?? '');
        setDate(props.edit.date !== null ? new Date(props.edit.date) : '');
        setCompletion(props.edit.completion ?? 0);
    }, [props.edit])


    return (
        <Panel
            isOpen={props.edit}
            onDismiss={props.dismissPanel}
            headerText="Edytuj Kamień Milowy"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='EditVentureMilestone'>
                <TextField required autoFocus label='Nazwa' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <TextField multiline label='Opis' value={description} onChange={(e) => setDescription(e.target.value || '')}/>
                <DatePicker
                    label="Data"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={date}
                    onSelectDate={(e) => setDate(e || '')}
                />
                <SpinButton
                    label={'Udział'}
                    labelPosition={'top'}
                    min={0}
                    step={1}
                    max={100}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={completion}
                    onChange={(e) => setCompletion(e.target.value || '')}
                />
            </form>
        </Panel>
    )
}

export default EditVentureMilestone;